import React from "react";
import { sidebarValueConstants } from "../pages/Workspace/sidebarutils";
import { optionModeConstants } from "../Utils/common";

const appState = {
    formData: [],
    setFormData: (formData: any) => { },
    uploadState: false,
    setuploadState: (uploadState: boolean) => { },
    addIpOptions: {},
    setAddIpOptions: (addIpOptions: any) => { },
    removeIpOptions: {},
    setRemoveIpOptions: (removeIpOptions: any) => { },
    optionCount: 1,
    setOptionCount: (optionCount: number) => { },
    auth: "",
    setAuth: (auth: string) => { },
    addChoiceTrigger: false,
    setAddChoiceTrigger: (trigger: boolean) => { },
    selectedMode: sidebarValueConstants.published,
    setSelectedMode: (selectedMode: string) => { },
    groupsList: [],
    setGroupsList: (groupsList: []) => { },
    contactGroup: "",
    setContactGroup: (contactGroup: string) => { },
    isListEmpty: false,
    setIsListEmpty: (isListEmpty: boolean) => { },
    optionMode: optionModeConstants.basic,
    setOptionMode: (optionMode: string) => { },
    isListSearchActive: false,
    setIsListSearchActive: (isListSearchActive: boolean) => { },
    profileAvatar: "",
    setProfileAvatar: (profileAvatar: string) => { },
    openLogicDialog: false,
    setOpenLogicDialog: (openLogicDialog: boolean) => { },
    currentFormtitle: "",
    setCurrentFormtitle: (currentFormtitle: string) => { },
    triggerRemoveLogic: false,
    setTriggerRemoveLogic: (triggerRemoveLogic: boolean) => { }
}

export const appContext = React.createContext(appState);


export default appContext;